export const creditCardImagesMapper: any = {
  CREDIT: {
    VIRTUAL: 'png/cards/credit-digital-card.png',
    PHYSICAL: 'png/cards/credit-physical-card.png',
  },
  DEBIT: {
    VIRTUAL: 'png/cards/debit-digital-card.png',
    PHYSICAL: 'png/cards/debit-physical-card.png',
  },
};

export const rulesResetOrderSubState = {
  CO: ['CANCELED', 'ERROR', 'SHIPPED', 'REQUESTED', 'DELIVERED', 'DELIVERED_BY_EXTERNAL'],
  CL: ['DELIVERED', 'DELIVERED_BY_EXTERNAL', 'REQUESTED'],
  DEFAULT: ['DELIVERED', 'DELIVERED_BY_EXTERNAL'],
};
